import { useEffect, useState } from "react";
import {
  catalogMeta as seedMeta,
  models as seedModels,
  providers as seedProviders,
} from "../data";
import type { CatalogMeta, Model, Provider } from "../types";

export function useCatalog() {
  const [models, setModels] = useState<Model[]>(seedModels);
  const [providers, setProviders] = useState<Provider[]>(seedProviders);
  const [meta, setMeta] = useState<CatalogMeta>(seedMeta);
  const [fromApi, setFromApi] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch("/api/catalog", { credentials: "include" });
        if (!res.ok) return;
        const data = (await res.json()) as {
          models?: Model[];
          providers?: Provider[];
          meta?: CatalogMeta;
        };
        if (cancelled) return;
        if (data.models?.length) setModels(data.models);
        if (data.providers?.length) setProviders(data.providers);
        if (data.meta) setMeta({ ...seedMeta, ...data.meta });
        setFromApi(true);
      } catch {
        /* use seed */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { models, providers, meta, fromApi };
}
